import Header from "@components/inc/dashboard/header";
import { FC, ReactNode } from "react";
import { Helmet } from "react-helmet";

interface Props {
    title: string;
    children: ReactNode;
}

const DashboardLayout: FC<Props> = ({ title, children }) => {
    return (
        <section>
            <Helmet>
                <title>{title}</title>
            </Helmet>

            <Header />

            <main className="dashboard-content py-6 root-container">
                {children}
            </main>
        </section>
    );
};

export default DashboardLayout;
